/**
 * relativeTime.js — « il y a 3 min » / « 3 min ago » selon la langue active.
 *
 * Intl.RelativeTimeFormat plutôt que des clés i18n par unité : pluriels et
 * tournures (« hier », « yesterday ») sont gérés par le navigateur pour
 * chaque langue, sans table à maintenir.
 */
const UNITS = [
  { unit: 'day',    ms: 24 * 60 * 60 * 1000 },
  { unit: 'hour',   ms: 60 * 60 * 1000 },
  { unit: 'minute', ms: 60 * 1000 },
];

/**
 * @param {Date|string|number|null} date
 * @param {string} language code i18n (ex. 'fr', 'en-GB')
 * @param {number} [now=Date.now()]
 * @returns {string|null} null si la date est absente ou illisible
 */
export function formatRelativeTime(date, language, now = Date.now()) {
  if (date === null || date === undefined) return null;
  const time = new Date(date).getTime();
  if (Number.isNaN(time)) return null;

  const diff = time - now;
  const rtf = new Intl.RelativeTimeFormat(language || 'fr', { numeric: 'auto', style: 'short' });
  const match = UNITS.find(({ ms }) => Math.abs(diff) >= ms);
  if (!match) return rtf.format(0, 'second');
  return rtf.format(Math.round(diff / match.ms), match.unit);
}
